import { FeatureToggleClientService } from 'feature-toggle-client';
export const AgentResponseTimeAlert = 'agent-response-time-alert';
export const CustomerResponseTimeAlerts = 'customer-response-time-alerts';
export const InsertAttachmentIntoDeskChat = 'insert-attachment-into-desk-chat';
export const InsertExternalAttachmentIntoDeskChat = 'insert-external-attachment-into-desk-chat';
export const RecordAudio = 'record-audio';
export const ActiveMessagesPermission = 'active-messages-permission';
export const MessageBeforeAutoClosing = 'message-before-auto-closed';
export class GeneralSettingsFeatures {
    static isAgentResponseTimeAlertEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(AgentResponseTimeAlert);
    }
    static isCustomerResponseTimeAlertEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(CustomerResponseTimeAlerts);
    }
    static isInsertAttachmentIntoDeskChatEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(InsertAttachmentIntoDeskChat);
    }
    static isInsertExternalAttachmentIntoDeskChatEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(InsertExternalAttachmentIntoDeskChat);
    }
    static isSendAudioRecordingOnDeskEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(RecordAudio, false);
    }
    static isActiveMessageAutoClosedEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(MessageBeforeAutoClosing, false);
    }
}
